import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  urlRoot: "/sales_billings",

  initialize() {
    InboomaBaseModel.prototype.initialize.apply(this);
  },

  _save(key, val, options) {
    //this.beforeSave(key, val, options);
    console.log("save sales billing model hook", key, val, options);
    return Backbone.Model.prototype.save.call(this, key, val, options);
  },

  _rbac: {
    admin: {
      read: true,
      write: true,
      writex: true,
      edit: true,
      remove: true,
      filter_by_location: true,
    },
    user: {
      read: true,
      write: true,
      writex: false,
      edit: false,
      remove: false,
    },
    manager: {
      read: true,
      write: true,
      writex: true,
      edit: false,
      remove: true,
      filter_by_location: true,
    },
    "booking-manager": {
      read: false,
      write: false,
      writex: false,
      edit: false,
      remove: false,
      filter_by_location: true,
    },
    "manager-location": {
      read: true,
      write: true,
      writex: true,
      edit: false,
      remove: false,
    },
    mediator: {
      read: true,
      write: false,
      writex: false,
      edit: false,
      remove: false,
    },
    "garage-staff": {
      read: false,
      write: false,
      writex: false,
      edit: false,
      remove: false,
    },
    guide: {
      read: true,
      write: false,
      writex: false,
      edit: false,
      remove: false,
    },
  },

  defaults: {
    id: "",
    location_id: "",
    location_name: "",
    file: "",
    client_id: "",
    date: "",
    created: null,
    modified: null,
    deleted: null,
    created_by: null,
    modified_by: null,
    accumulated_invoice: null,
  },
});
